import { render, staticRenderFns } from "./CreateDirectoryLevel.vue?vue&type=template&id=74e4c5cf&scoped=true&"
import script from "./CreateDirectoryLevel.vue?vue&type=script&lang=ts&"
export * from "./CreateDirectoryLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e4c5cf",
  null
  
)

export default component.exports